module.exports = __webpack_public_path__ + "static/media/levelChamonix.3b466df5.jpg";